import { gql } from 'graphql-request'
import { useQuery } from '@hooks/graphql'
import { Link } from 'react-router-dom'
import { cn } from "@/helpers/utils"
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { Skeleton } from '@/components/ui/skeleton'

const ONBOARDING_CHECKLIST_QUERY = gql`
  query educatorOnboardingChecklist {
    me {
      profile: newProfile {
        educatorOnboardingChecklistCompleted
        educatorOnboardingChecklist {
          createdClassroom
          invitedStudents
          invitedEducators
          createdAndAssignedSeries
          createdAndAssignedTutor
          gatheredInsights
        }
      }
    }
  }
`

const OnboardingChecklist = () => {
  const {
    isLoading,
    data: {
      me: {
        profile: {
          educatorOnboardingChecklist: onboardingChecklist = {}
        } = {}
      } = {}
    } = {}
  } = useQuery({
    queryKey: ['educatorOnboardingChecklist'],
    gqlQuery: ONBOARDING_CHECKLIST_QUERY
  })

  const items = [
    {
      emoji: '🏠',
      label: 'Create a classroom',
      completed: onboardingChecklist.createdClassroom,
      to: '/educators/classrooms'
    },
    {
      emoji: '📚',
      label: 'Create and assign a pathway',
      completed: onboardingChecklist.createdAndAssignedSeries,
      to: '/educators/courses'
    },
    {
      emoji: '👩‍🏫',
      label: 'Create and assign a tutor',
      completed: onboardingChecklist.createdAndAssignedTutor,
      to: '/educators/tutors'
    },
    {
      emoji: '👩‍🎓',
      label: 'Invite students',
      completed: onboardingChecklist.invitedStudents,
      to: '/educators/classrooms'
    },
    {
      emoji: '📊',
      label: 'Gather insights',
      completed: onboardingChecklist.gatheredInsights,
      to: '/educators/classrooms'
    },
    {
      emoji: '👩‍🏫',
      label: 'Invite educators',
      completed: onboardingChecklist.invitedEducators,
      to: '/educators/organization/educators'
    }
  ]

  return (
    <div className='flex flex-col gap-2'>
      <For each='item' of={items}>
        <div
          key={item.label}
          className={cn(
            'p-5 flex items-center gap-3 border rounded-md',
            item.completed && 'text-muted-foreground'
          )}
        >
          <div className={cn(!item.completed && 'ml-1')}>
            <Choose>
              <When condition={isLoading}></When>
              <When condition={item.completed}>
                <CheckCircleIcon className='size-6 sidebar-ring' />
              </When>
              <Otherwise>
                {item.emoji}
              </Otherwise>
            </Choose>
          </div>
          <div className={cn(item.completed ? 'line-through' : 'ml-1')}>
            <Choose>
              <When condition={isLoading}>
                <Skeleton className='w-32 h-4' />
              </When>
              <Otherwise>
                <Link to={item.to}>{item.label}</Link>
              </Otherwise>
            </Choose>
          </div>
        </div>
      </For>
    </div>
  )
}

export default OnboardingChecklist
